<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-toolbar-title class="indigo--text"
                >Descargue log de la aplicacion
              </v-toolbar-title>
              <v-btn
                depressed
                outline
                icon
                fab
                dark
                color="primary"
                small
                @click="downloadFile()"
              >
                <v-icon>cloud_download</v-icon>
              </v-btn>
            </v-toolbar>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
import { async } from "q";
import { log } from "util";

export default {
  components: {},
  data() {
    return {};
  },

  created() {},
  mounted() {},
  computed: {},
  methods: {
    downloadFile() {
      let idUserLogged = this.$store.getters.userLogged.id;
      let filename = "application.log";
      let that = this;
      axios({
        url: "/public/downloadLog/" + idUserLogged,
        method: "GET",
        responseType: "blob",
      })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
  },
};
</script>
